import { Link } from '@material-ui/core';
import React from 'react';
import { CatalogueLinkProps } from './catalogue-link-props';

/**
 * A link to the catalogue page.
 * @param props
 */
export const CatalogueLink: React.FC<CatalogueLinkProps> = (props) => {
  let href = `/catalogue/${props.type}/${props.id}?db=${props.db}`;

  if (typeof (props.user) === 'number') {
    href += `&user=${props.user}`;
  }

  if (props.trait) {
    href += `&scenario=${props.trait}`;
  }

  if (props.asbvs) {
    href += `&asbvs=${props.asbvs}`;
  }

  return (
    <Link
      href={href}
      target="_blank"
      className={props.className}
    >
      {props.label}
    </Link>
  );
};
